import type { FC } from "react";

const deployedStage: string | undefined = import.meta.env.VITE_STAGE;
const stageLabel = (deployedStage ?? (import.meta.env.DEV ? "local" : undefined))?.toUpperCase();

export const EnvironmentRibbon: FC = () => {
  if (!stageLabel || stageLabel === "PROD") return null;

  return (
    <div className="pointer-events-none fixed top-7.5 -left-21.75 z-9999 flex h-8 w-72.5 -rotate-45 items-center bg-warning shadow-md print:hidden">
      <span className="w-full truncate px-11.25 text-center text-xs font-bold tracking-widest text-warning-foreground">
        {stageLabel}
      </span>
    </div>
  );
};
